module.exports = __webpack_public_path__ + "img/k.b1db6f70.png";